import { useAtomValue } from "jotai";
import type {Step} from "../../components/stepper/Step.ts";
import { ScanAtom } from "../3-perform-scan/ScanAtom.tsx";
import {UploadWidget} from "./UploadWidget.tsx";

export function useUploadResultsStep(): Step {
    const scanResult = useAtomValue(ScanAtom)
    return {
        name: "Upload Results",
        isAvailable: scanResult !== null,
        isCompleted: false,
        Widget: UploadWidget
    }
}